import { useState } from 'react';
import { withStyles, Tabs, Tab } from '@material-ui/core';
import styles from './styles';
import ToolTip from '../../StyledToolTip';

const TabContainer = ({
  classes,
  tabs,
  defaultTab = 0,
  variant = 'fullWidth',
  orientation = 'horizontal',
  onChange
}) => {
  const [selectedTab, setSelectedTab] = useState(defaultTab);

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
    onChange?.(newValue);
  };

  return (
    <>
      <div className={classes.header}>
        <Tabs
          value={selectedTab}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
          variant={variant}
          orientation={orientation}>
          {tabs.map((tab) => (
            <Tab
              key={tab.label}
              label={
                <ToolTip title={tab.isEnabled ? `Edit ${tab.label}` : tab.disabledTooltipText}>
                  <span>{tab.label}</span>
                </ToolTip>
              }
              disabled={!tab.isEnabled}
              classes={{
                root: classes.tabRoot,
                selected: classes.tabSelected,
                disabled: classes.tabDisabled
              }}
            />
          ))}
        </Tabs>
      </div>
      <div className={classes.content}>{tabs[selectedTab]?.component}</div>
    </>
  );
};

export default withStyles(styles)(TabContainer);
